import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { PrimaryButton } from "../../../shared/buttons/PrimaryButton.styled";
import TakeOffSourceLogo from "./TakeOffSourceLogo";
import type { QtoSourceId } from "../../../../integrations/qto/registry";

interface TakeOffLoginShellProps {
  sourceId: QtoSourceId;
  submitLabel: string;
  busy: boolean;
  submitDisabled: boolean;
  onSubmit: () => void;
  /** Whatever the source needs above the button: credential fields, or a line of explanation. */
  children?: React.ReactNode;
}

/**
 * The chrome every take-off sign-in shares — the form element, the logo, and the submit button with
 * its spinner. What sits between them differs entirely by source, so each supplies its own.
 */
const TakeOffLoginShell: React.FC<TakeOffLoginShellProps> = ({
  sourceId,
  submitLabel,
  busy,
  submitDisabled,
  onSubmit,
  children,
}) => (
  <Box
    component="form"
    noValidate
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
    sx={{ p: 2 }}
  >
    <Box sx={{ mb: "16px" }}>
      <TakeOffSourceLogo type={sourceId} variant="drawer" />
    </Box>

    {children}

    <PrimaryButton type="submit" fullWidth disabled={submitDisabled} sx={{ height: "32px" }}>
      {busy ? <CircularProgress size={20} color="inherit" /> : submitLabel}
    </PrimaryButton>
  </Box>
);

export default TakeOffLoginShell;
